import { createContext, useContext, useEffect, useState } from "react";

const OfficeFilterContext = createContext({
  officeId: "",
  setOfficeId: () => {},
});

export function OfficeFilterProvider({ children }) {
  const [officeId, setOfficeIdState] = useState(() => {
    try {
      return localStorage.getItem("eme_office_filter") || "";
    } catch {
      return "";
    }
  });

  const setOfficeId = (id) => {
    setOfficeIdState(id || "");
    try {
      if (id) localStorage.setItem("eme_office_filter", id);
      else localStorage.removeItem("eme_office_filter");
    } catch {
      // ignore
    }
  };

  // Clear filter on logout (when token disappears)
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "token" && !e.newValue) setOfficeId("");
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return (
    <OfficeFilterContext.Provider value={{ officeId, setOfficeId }}>
      {children}
    </OfficeFilterContext.Provider>
  );
}

export const useOfficeFilter = () => useContext(OfficeFilterContext);
